import router from "../../app/router"

import home from "./home/index.vue"
//lightUpHometown
//const LHrule = () => import('./lightUpHometown/pages/rule')
//const LHscoreDetails = () => import('./lightUpHometown/pages/scoreDetails')
//const LHprizes = () => import('./lightUpHometown/pages/prizes')
//epidemic
const Epidemic = () => import('./epidemic/pages/index')
const EpidemicDetails = () => import('./epidemic/pages/details')
//other
//const Sms = () => import('../../auth/login/sms')
//const Calendar = () => import('../../pages/calendar')
//const SelectStation = () => import('../../pages/selectStation')
//const SelectCity = () => import('../../pages/selectCity')

const routes = [
  {
    path: "/festivalActivity/home",
    component: home
  },
  //lightUpHometown
  /*{
    path: "/festivalActivity/lightUpHometownRule",
    component: LHrule,
    meta: {
      title: '活动规则',
      tintColor: '255,55,79,1',
      tintColorStyle: '0'
    }
  },
  {
    path: "/festivalActivity/lightUpHometownPrizes",
    component: LHprizes,
    meta: {
      title: '我的奖品',
      tintColor: '255,55,79,1',
      tintColorStyle: '0',
      auth: true
    }
  },
  {
    path: "/festivalActivity/lightUpHometownScoreDetails",
    name: "/festivalActivity/lightUpHometownScoreDetails",
    component: LHscoreDetails,
    meta: {
      title: '我的春运津贴',
      tintColor: '255,55,79,1',
      tintColorStyle: '0',
      auth: true
    }
  },*/
  //epidemic
  {
    path: "/festivalActivity/epidemic",
    name: "/festivalActivity/epidemic",
    component: Epidemic,
    meta: {
      title: '出行防疫指南'
    }
  },
  {
    path: "/festivalActivity/epidemic-details",
    name: "festivalActivity/epidemic-details",
    component: EpidemicDetails,
    meta: {
      title: ' '
    }
  },
  //other
  /*{
    path: '/login/sms',
    name: 'login/sms',
    component: Sms,
  },
  {
    path: '/pages/calendar',
    name: "pages/calendar",
    component: Calendar,
    meta: {
      title: "选择出发日期"
    }
  },
  {
    path: "/pages/selectStation",
    name: "pages/selectStation",
    component: SelectStation
  },
  {
    name: 'pages/selectCity',
    path: '/pages/selectCity',
    component: SelectCity
  }*/
]

router.addRoutes(routes)

export default router



// WEBPACK FOOTER //
// ./src/projects/festivalActivity/router.js